import Handlebars from "../handlebars/handlebars";
import Siema from 'siema';
import errorResponseHandler from "../errors/errorResponseHandler";
import viewFilesHtml from "./viewFiles.hbs";
import viewFilesListHtml from "./viewFilesList.hbs";

const CANCEL_ACTION = '.js-action--cancel';
const FILE_LIST_ELEMENT = '.js-element--viewFilesList';
const CAROUSEL_ELEMENT = '.js-element--carousel';
const CAROUSEL_SLIDE_ELEMENT = '.carousel-slide';
const CAROUSEL_PREV_ACTION = '.js-action--carouselPrev';
const CAROUSEL_NEXT_ACTION = '.js-action--carouselNext';
const LOADING_CLASSES = [
    'isDelayed',
    'isDelayed_med'
];

class ViewFilesController {
    constructor (modalInstance, container, currentItem) {
        this.modalInstance = modalInstance;
        this.container = container;
        this.currentItem = currentItem;
        this.template = viewFilesHtml;

        this.handleClick = this.handleClick.bind(this);
        this.renderViewFilesList = this.renderViewFilesList.bind(this);

        this.enableUI()
        this.render()
    }

    enableUI () {
        this.container.addEventListener('click', this.handleClick, false);
        return this;
    }

    render () {
        this.container.innerHTML = this.template(this.currentItem);
        this.renderFiles();
    }

    renderFiles () {
        Collaterate.Project.getItemTemplatePreview(this.currentItem, 500)
            .then(this.renderViewFilesList)
            .then((images) => {

                if (images.length <= 1) {
                    return;
                }

                const carousel = new Siema({
                    selector: CAROUSEL_ELEMENT,
                    loop: 'true'
                });

                this.container.querySelector(CAROUSEL_PREV_ACTION).addEventListener('click', () => carousel.prev());
                this.container.querySelector(CAROUSEL_NEXT_ACTION).addEventListener('click', () => carousel.next());

                carousel.init();
            })
            .catch(errorResponseHandler.generateErrorHandler())
    }

    renderViewFilesList (templatePreview) {
        const listContainer = this.container.querySelector(FILE_LIST_ELEMENT);

        listContainer.innerHTML = viewFilesListHtml(templatePreview);

        const images = listContainer.querySelectorAll('img');
        for (let i = 0; i < images.length; i++) {
            images[i].addEventListener('load', e => {
                const slide = e.target.closest(CAROUSEL_SLIDE_ELEMENT);
                LOADING_CLASSES.forEach(loadingClass => slide.classList.remove(loadingClass));
            });
        }
        return images;
    }

    handleClick (e) {
        if (e.target.matches(CANCEL_ACTION)) {
            e.preventDefault();
            this.modalInstance.cancel();
        }
    }

}
export default ViewFilesController;